import { RealTimeAction } from '@/_core/fluxstore/types';
import { useStorymapCardDetailsStore } from '@/store/main/StorymapCardDetails/useModule';
import { StorymapState } from '../types';
import { useStorymapStore } from '../useModule';

const { registerReducer } = useStorymapStore();

export class UpdateCardLinkedItemType extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'UpdateCardLinkedItemType';

    public constructor(public id: string, public linkedItemTypeId: string | null, public linkedItemTypeName: string | null) {
        super(UpdateCardLinkedItemType.ACTION_TYPE);
    }
}

const reducer = (state: StorymapState, action: UpdateCardLinkedItemType): void => {
    const card = [...state.activities, ...state.tasks, ...state.subtasks].find((x) => x.id === action.id);

    if (card) {
        card.linkedItemTypeId = action.linkedItemTypeId;
        card.linkedItemTypeName = action.linkedItemTypeName;
    }

    const detailsStore = useStorymapCardDetailsStore();
    if (detailsStore.state.card?.id === action.id) {
        detailsStore.state.card.linkedItemTypeId = action.linkedItemTypeId;
        detailsStore.state.card.linkedItemTypeName = action.linkedItemTypeName;
    }
};

//@ts-ignore
registerReducer(UpdateCardLinkedItemType.ACTION_TYPE, reducer);
